(function () {
  function initReveal(scope) {
    var items = scope.querySelectorAll('[data-ph-reveal]:not([data-ph-ready])');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (item) { item.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    items.forEach(function (item) { item.dataset.phReady = 'true'; observer.observe(item); });
  }

  function initRails(scope) {
    scope.querySelectorAll('[data-ph-rail]:not([data-ph-ready])').forEach(function (rail) {
      rail.dataset.phReady = 'true';
      if (!rail.classList.contains('PHome__AutoRail')) return;
      var track = rail.firstElementChild;
      if (!track || track.children.length < 2) return;
      Array.from(track.children).forEach(function (item) {
        var clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('inert', '');
        clone.querySelectorAll('[id]').forEach(function (node) { node.removeAttribute('id'); });
        track.appendChild(clone);
      });
      track.style.setProperty('--ph-duration', Math.max(30, track.children.length * 3.5) + 's');
      requestAnimationFrame(function () { track.classList.add('is-ready'); });
    });
  }

  function initCounts(scope) {
    scope.querySelectorAll('[data-ph-count]:not([data-ph-ready])').forEach(function (counter) {
      counter.dataset.phReady = 'true';
      var target = parseInt(counter.dataset.phCount, 10);
      if (!target) return;
      var observer = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        var start = performance.now();
        function frame(now) {
          var progress = Math.min(1, (now - start) / 1200);
          counter.textContent = Math.round(target * progress).toLocaleString();
          if (progress < 1) requestAnimationFrame(frame);
        }
        requestAnimationFrame(frame);
        observer.disconnect();
      }, { threshold: 0.4 });
      observer.observe(counter);
    });
  }

  function init(scope) {
    initReveal(scope);
    initRails(scope);
    initCounts(scope);
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}());
